import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  translation_ar: {
    GLOBAL:{
      cancel_button:'الغاء',
      save_button:'حفظ',
      GRID_NO_DATA:'لا توجد بيانات',
      GRID_NO_RESULT_DATA:'لا توجد بيانات',
      action_edit:'تعديل',
      action_view:'عرض',
      action_delete:"حذف",
      action_rating:'تقييم',
      SEARCH_RESULT_OF_SEARCH:"النتيجة",
      SEARCH_SEARCH_BUTTON:'بحث',
      SEARCH_CLEAR_BUTTON:"مسح",
      Save:'حفظ',
      close:'اغلاق',
      SEARCH_RESULT_OF_selected:"المحددة",
      alertPopup:'تحديث بيانات المستخدم',
      updateUserInfo:'تحديث',
      endSessionMessage:'تم انتهاء الجلسة الخاصة بك سيتم تحويلك لصفحة التسجل خلال',
      endSessionMessageUnits:'ثانية',
      sorryMessage:"عذرا لم نتمكن من تحويلك الى صفحة تسجيل الدخول، رجاءا قم  بتسجيل الدخول مره اخرى من النظام الرئيسي",
      pageNotFoundMessage:"عذرا الصفحة غير موجوده",
      clear:'مسح'
    },
    LOGIN:{
      login_title:'تسجيل دخول',
      company_name:'نظام Milestone',
      company_title:'لادارة المجمعات السكنية والعقارات',
      wellcome_message:'مرحبا بك في نظام Milestone',
      Introductory_message:'هذا نظام آمن وستحتاج إلى تقديم تفاصيل تسجيل الدخول الخاصة بك للوصول إلى الموقع.',
      user_name:'اسم المستخدم',
      user_password:'كلمة المرور',
      checkbox_remember_me:'تذكرني',
      login:'تسجيل دخول',
      forget_password:'هل نسية كلمة المرور؟',
      footer_message:'مقدم من شركة ركن الحلول المتكاملة لتقنية المعلومات',
      reset_password_title:'أكتب رقم الهاتف الخاص بك لاستعادة كلمة المرور',
      phone_number:'رقم الهاتف',
      Submit:'أرسال',
      recived_sms_code_title:'أدخل الرمز المرسل اليك برسالة قصيرة',
      not_recivied_message:'لم يصلك الرمز ؟',
      reSend_message:'أعادة ارسال',
      new_password_form_title:'يرجى كتابة كلمة المرور الجديدة الان',
      confirm_user_password:'تأكيد كلمة المرور',
      save_changes_passwords:'حفظ التغييرات',
    },
    ERROR:{
      login_username_error:'اسم المستخدم مطلوب',
      login_userpassword_error:'يجب ادخال كلمة المرور',
      userName_or_password_error:'اسم المستخدم او كلمة المرور غير صحيحة'
      
    },
    SIDEMENU:{
      dashboard:'لوحة التحكم',
      Requests:'الطلبات',
      profiel:'الملف الشخصي',
      logout:'تسجيل خروج',
      units:'الوحدات'
    },
    DASHBOARD:{
      request_wait:'الطلبات  في الانتظار',
      request_canceled:'الطلبات الملغاة',
      request_completed:'الطلبات المكتملة',
      request_sum:'جميع الطلبات',
      unit_counts:'عدد الوحدات',
      title:'لوحة التحكم',
      request_new:'الطلبات الجديدة',
      show_status_title:'مخطط نسب الحالات للطلبات',
      show_RatedScore_title:'مخطط التقييم للطلبات'
    },
    ADVANCESEARCH:{
      title:'البحث عن عملاء',
      customer_name:'أسم العميل',
      customer_phone_number:'رقم الهاتف',
      Name_ofCumpany:"تاريخ التسجيل",
      fromDate:'من ',
      toDate:'الى',
      no_cutomerTypeData:'لا توجد بيانات',
      SelectCustomerWorkType:'نوع العميل',
      salesEmployee:'موظف المبيعات',
      selectedReason:'الغرض',
      no_resones:'لا توجد بيانات',
      advancesearch:'البحث المتقدم',
      applaySearch:'تطبيق البحث',
      sideOfWork:'جهة العمل',
      no_workside:'لا توجد بيانات',
      companyname:'اسم الشركة',
    },
    NETWORKMESSAGE:{
      addCustomerMessageSuccess:'تم اضافة المعلومات بنجاح',
      updateCustomerMessageSuccess:'تم تحديث المعلومات بنجاح',
      addCustomerMessageError:'خطء غير معروف',
      deleteErrorr:'خطء غير معروف',
      deleteSuccess:'تم الحذف بنجاح'
    },
    TOOLTIP:{
      EXPORT:'تصدير',
      IMPORT:'استيراد',
      CREATE:'انشاء',
      MAP:'خريطة',
      TELEGRAM:'تليكرام',
    },
    PROFILE:{
      email:'البريد الالكتروني',
      USER_TITLE:'معلومات المستخدم',
      FULL_NAME:"أسم المستخدم كامل",
      USERNAME:'اسم المستخدم',
      PHONE:"رقم الهاتف",
      UPDATE_BUTTON:"تحديث البيانات",
      
    },
    GRIDS:{

    },
    SIDESETTINGS:{
      title:'Grid Settings',
      close:'Close',
      directions:'Grid Body Directions'
    },
    APPVERSIONUPDATES:{
      title:'Update content of Version',
      close:'Close',
    }
  },
  translation_en: {
   GRIDS:{
      
   },
   SIDESETTINGS:{
       title:'Grid Settings',
       close:'Close',
       directions:'Grid Body Directions'
   }
  },
  main_translation:{}

};
export const TranslateSlice = createSlice({
  name: "translateData",
  initialState: initialState,
  reducers: {
    setTranslateEnglish:(state,action)=>{
      state.translation_en=action.payload
    },
    setTranslateArabic:(state,action)=>{
      state.translation_ar=action.payload
    },
    setMainTranslation:(state,action)=>{
       state.main_translation=action.payload
    }
  },
});

export const {
  setTranslateEnglish,
  setTranslateArabic,
  setMainTranslation
} = TranslateSlice.actions;

// export const sideMenuMode = state => state.settingsData.sideMenuMode;

export default TranslateSlice.reducer;
